import { ContractorTopSellRptConstants } from '../constants';
export function ContractorTopSellRpt(state = {}, action) {
    switch (action.type) {
        case ContractorTopSellRptConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case ContractorTopSellRptConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case ContractorTopSellRptConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case ContractorTopSellRptConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case ContractorTopSellRptConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case ContractorTopSellRptConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case ContractorTopSellRptConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state;
    }
}
